<script>
  import { ArrowLeft, Cloud, CloudOff, LoaderCircle, Radio, X } from 'lucide-svelte';

  export let online = true;
  export let recording = false;
  export let stopping = false;
  export let status = 'Sẵn sàng';
  export let pendingChunks = 0;
  export let onClose = () => {};
</script>

<header class="camera-header">
  <button type="button" class="glass-icon" aria-label="Đóng camera" title="Đóng camera" on:click={onClose}>
    <span class="mobile-back"><ArrowLeft size="19" /></span>
    <span class="desktop-close"><X size="19" /></span>
  </button>

  <div class="status-cluster">
    <div class:recording class="glass-pill status-pill">
      {#if stopping}
        <span class="spin"><LoaderCircle size="15" /></span>
      {:else if recording}
        <Radio size="15" />
      {:else if online}
        <Cloud size="15" />
      {:else}
        <CloudOff size="15" />
      {/if}
      <span>{online ? status : 'Mất mạng, đang lưu trên thiết bị'}</span>
    </div>

    {#if pendingChunks > 0}
      <div class="glass-pill queue-pill" title={`${pendingChunks} đoạn đang chờ đồng bộ`}>
        <Cloud size="14" />
        <span>{pendingChunks}</span>
      </div>
    {/if}
  </div>
</header>

<style>
  .camera-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 70;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
    padding: max(0.75rem, env(safe-area-inset-top)) 0.85rem 0;
    pointer-events: none;
  }

  .glass-icon,
  .glass-pill {
    pointer-events: auto;
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.24);
    background: linear-gradient(145deg, rgba(255, 255, 255, 0.2), rgba(15, 23, 42, 0.26));
    box-shadow:
      0 10px 35px rgba(0, 0, 0, 0.28),
      inset 0 1px 0 rgba(255, 255, 255, 0.28);
    backdrop-filter: blur(24px) saturate(165%);
    -webkit-backdrop-filter: blur(24px) saturate(165%);
  }

  .glass-icon {
    display: grid;
    place-items: center;
    width: 2.75rem;
    height: 2.75rem;
    border-radius: 999px;
    transition: transform 160ms ease, background 160ms ease;
  }

  .glass-icon:hover {
    transform: scale(1.04);
    background: rgba(255, 255, 255, 0.28);
  }

  .status-cluster {
    display: flex;
    justify-content: flex-end;
    gap: 0.45rem;
    min-width: 0;
  }

  .glass-pill {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    min-height: 2.4rem;
    padding: 0.55rem 0.8rem;
    border-radius: 999px;
    font-size: 0.76rem;
    font-weight: 650;
    letter-spacing: 0.01em;
  }

  .status-pill {
    max-width: min(68vw, 32rem);
  }

  .status-pill span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .status-pill.recording {
    border-color: rgba(255, 110, 110, 0.55);
    background: linear-gradient(145deg, rgba(239, 68, 68, 0.52), rgba(127, 29, 29, 0.34));
  }

  .queue-pill {
    color: #fef3c7;
  }

  .desktop-close {
    display: none;
  }

  .spin {
    animation: spin 0.9s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media (min-width: 768px) {
    .camera-header {
      padding: 1rem 1.15rem 0;
    }

    .desktop-close {
      display: block;
    }

    .mobile-back {
      display: none;
    }
  }
</style>
